"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KEY_CODES;
(function (KEY_CODES) {
    KEY_CODES[KEY_CODES["Enter"] = 13] = "Enter";
    KEY_CODES[KEY_CODES["Spacebar"] = 32] = "Spacebar";
    KEY_CODES[KEY_CODES["ArrowUp"] = 38] = "ArrowUp";
    KEY_CODES[KEY_CODES["ArrowDown"] = 40] = "ArrowDown";
    KEY_CODES[KEY_CODES["ArrowRight"] = 39] = "ArrowRight";
    KEY_CODES[KEY_CODES["ArrowLeft"] = 37] = "ArrowLeft";
})(KEY_CODES = exports.KEY_CODES || (exports.KEY_CODES = {}));
function isSelectKey(keyCode) {
    switch (keyCode) {
        case KEY_CODES.Enter:
        case KEY_CODES.Spacebar:
            return true;
        default:
            return false;
    }
}
exports.isSelectKey = isSelectKey;
//# sourceMappingURL=keyCodes.js.map